import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import moment from 'moment';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  homedir: validator('presence', true),
  user: [validator('belongs-to'), validator('presence', true)],
  username: [
    validator('format', {
      allowBlank: true,
      regex: /^[a-zA-Z0-9]+(?:[-_][a-zA-Z0-9]+)*$/,
    }),
    validator('unique', {
      messageKey: 'forms.sftp-user.messages.username.unique',
    }),
  ],
  passwordValid: [
    validator('number', {
      allowString: true,
      integer: true,
      gt: 0,
    }),
  ],
});

export default class SftpUserModel extends Model.extend(Validations) {
  @attr('string') homedir;
  @attr('string') ip;
  @attr('string') killdate;
  @attr('string') livedate;
  @attr('boolean') manualIp;
  @attr('string') password;
  @attr('string') passwordCreated;
  @attr('string', { defaultValue: 3 }) passwordValid;
  @attr('string') purpose;
  @attr('string') username;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;
  @attr cmsModified;

  // Relations
  @belongsTo('user', { async: true, inverse: 'sftpUsers' }) user;

  // Getter and setter
  get displayHeadline() {
    return this.homedir;
  }

  get displayLabel() {
    return this.homedir;
  }

  get isExpired() {
    return moment().isAfter(this.killdate);
  }

  get isPasswordInvalid() {
    return !this.isPasswordValid;
  }

  get isPasswordValid() {
    let validUntil = moment(this.passwordCreated).add(
      this.passwordValid,
      'days',
    );

    return moment().isBefore(validUntil);
  }

  get isUserInvalid() {
    return !this.isUserValid;
  }

  get isUserValid() {
    return this.isPasswordValid && !this.isExpired;
  }

  get userDisplayLabel() {
    return this.purpose || this.homedir;
  }
}
